import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { NavLink } from "react-router-dom";

const ComplianceCampaign = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // State variables
  const [data, setLessons] = useState([]);
  const [links, setLinks] = useState([]);
  const [deleted, setDeleted] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedPoliceId, setSelectedPoliceId] = useState(null);

  // Handle navigation to Question page with lesson id
  const handleQuestionClick = (id) => {
    navigate(`/question/${id}`);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/compliance-campaigns/campaign-assignments/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        showToast(t("CampaignAssignmentdeletedsuccessfully"), "success");
        fetchCampaignAssignment("");
        setShowModal(false);
      } else {
        showToast(
          result.message || t("failedtodeleteCampaignAssignment"),
          "error"
        );
        setShowModal(false);
      }
    } catch (error) {
      console.error("Delete Error:", error);
      showToast(t("somethingwentwrong"), "error");
      setShowModal(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchVal !== "") {
      const filteredData = data.filter((item) =>
        item.assignable_type?.toLowerCase().includes(searchVal.toLowerCase())
      );
      setLessons(filteredData);
    } else {
      fetchCampaignAssignment("");
    }
  }, [searchVal]);

  // Fetch campaign assignments data
  const fetchCampaignAssignment = async (url) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${api_url}/compliance-campaigns/campaign-assignments${
          id ? `/${id}` : ""
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Assignments:", result.data);
      setLessons(result.data || []);
      setLinks(result.links || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast(t("errorfetchingdata"), "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaignAssignment("");
  }, [id]);

  // Define table columns
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "assignable_type",
        header: () => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              whiteSpace: "nowrap",
            }}
          >
            <i className="bi bi-clipboard-data"></i>
            {t("CampaignAssignment")}
          </div>
        ),
        colName: t("CampaignAssignment"),
      },
      {
        accessorKey: "id",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src="/images/fi_alert-octagon.png" alt="Source" />
            {t("Action")}
          </div>
        ),
        cell: ({ getValue }) => {
          const id = getValue();
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                className="iconDel"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedPoliceId(id);
                  setShowModal(true);
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <img src="/images/fi_trash-2.png" alt="Delete" />
                {t("Delete")}
              </div>
            </div>
          );
        },
        colName: t("Action"),
      },
    ],
    [t]
  );

  // Create a table instance
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  // const handleSurveyRowClick = (id) => {
  //   console.log("Navigating to PoliceDetail with ID:", id);
  //   navigate(`/PoliceDetail/${id}`);
  // };

  // const handleAddComplianceAssignment = () => {
  //   console.log("Navigating to AddCampaignAssignment with ID:", id);
  //   if (!id || (typeof id !== "string" && typeof id !== "number")) {
  //     showToast(t("InvalidCampaignId"), "error");
  //     return;
  //   }
  //   navigate(`/ComplianceCampaignDetail/${id}/AddCampaignAssignment`);
  // };

  return (
    <div className="p-4 mb-4">
      <div className="pageTitle mb-4">{t("CampaignAssignment")}</div>
      <div className="primaryBlueBox p-5 mb-4">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">
              {t("SearchCampaignAssignment")}
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbyname")}
                aria-label="Search Policy"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-1">
            <div className="vrLine"></div>
          </div>
          <div className="col-md-7">
          <NavLink
  className="btnWhiteGradient mt-4"
  to={`/ComplianceCampaignDetail/${id}/AddCampaignAssignment`}
>
  <i className="bi bi-envelope me-2 mt-3 h6"></i>{" "}
  {t("AddCampaignAssignment")}
</NavLink>

          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <div
            className="spinner-border loader-api"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          ></div>
        </div>
      ) : (
        <div className="bg-light px-3 py-3 lessonsTableWrapper resTable overflow-auto">
          {window.innerWidth < 768 ? (
            table.getRowModel().rows.map((row) => (
              <div
                key={row.id}
                className="stacked-row"
                // onClick={() => handleSurveyRowClick(row.original.id)}
              >
                {row.getVisibleCells().map((cell) => (
                  <div key={cell.id} className="stacked-cell">
                    <strong className="me-1">
                      {cell.column.columnDef.colName}:
                    </strong>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <table className="table table-bordered table-hover">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className="rowAnchor"
                        // onClick={cell.id.includes('id') ? null : () => handleSurveyRowClick(row.original.id)}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      <div className="navigationWrapper">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? " active " : ""} ${
                link.url === null ? " disabled " : ""
              }`}
              onClick={
                link.url !== null
                  ? () => fetchCampaignAssignment(link.url)
                  : undefined
              }
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("ConfirmDelete")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("AreyousureyouwanttodeletethisCampaignAssignment")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("Cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={() => handleDelete(selectedPoliceId)}
            disabled={loading}
          >
            {loading ? t("Deleting...") : t("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ComplianceCampaign;
